<template>
    <ModalEdition :isEdition="params.id != null" :modalId="'modalEditCategorie'" ref="modalCategorieRef"@save="saveCategorie">
        <div class="form">
            <div class="form-group">
                <label for="categorie_libelle">Libellé</label>
                <input type="text" class="form-control" id="categorie_libelle" v-model="categorie.libelle" />
            </div>
        </div>
    </ModalEdition>
</template>

<script>
import Axios from '@/services/axios.service';
import ModalEdition from '../../../../components/ModalEdition.vue';

export default {
    name: 'categorieEdit',
    components: {
        ModalEdition
    },
    props: {
        params: {
            type: Object,
            required: false,
            default: () => ({}),
        },

    },
    data() {
        return {
            categorie: {},
            errors: [],
        }
    },
    methods: {
        getCategorie(id) {
            if (id) {
                Axios.get('/categorie/' + id).then(res => {
                    this.categorie = res.data;
                })
            }
        },
        saveCategorie() {
            this.errors = []
            Axios.post('/categorie', this.categorie)
                .then(() => {
                    this.$refs.modalCategorieRef.closeModal();
                    this.$emit('saved');
                }).catch(err => {
                    console.error('Erreur lors de la sauvegarde de la catégorie:', err);
                });
        },
    },
    watch: {
        params: {
            handler(params) {
                if (params.id != null) {
                    this.getCategorie(params.id);
                } else {
                    this.categorie = {};
                }
            },
            deep: true,
        },
    },
}
</script>

<style></style>
